import * as React from 'react'
import Spinner from '../components/Spinner'
import { emailValidate } from '../utils'
import { Redirect } from 'react-router-dom'

class LoginScreen extends React.Component {
  state = {
    email: '',
    password: ''
  }

  login = () => {
    const { email, password } = this.state
    this.props.loginWithEmailPassword( email, password )
  }

  enableBtn() {
    const { email, password } = this.state

    if( password.length<6 ) return true
    if ( !emailValidate(email) ) return true
    return false
  }

  componentDidMount() {
    if( this.props.location.state && this.props.location.state.logout && this.props.location.state.logout===true) {
      this.props.logOut();
    }
  }

  render() {
    const { message, loading } = this.props.app

    if( loading ) return <Spinner type="full" />
    else if(this.props.login.id) return <Redirect to="/manageapp" />
    
    return (
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <form>
                <label htmlFor="exampleInputEmail1">Adres email</label>
                <input 
                  type="email" 
                  className="form-control" 
                  placeholder="Adres email" 
                  onChange={event=>this.setState({ email: event.target.value })}
                  defaultValue={this.state.email}
                />

                <label htmlFor="exampleInputEmail1">Hasło</label>
                <input 
                  type="password" 
                  className="form-control" 
                  placeholder="Adres email" 
                  onChange={event=>this.setState({ password: event.target.value })}
                  defaultValue={this.state.password}
                />
              
                <button disabled={ this.enableBtn() } onClick={ this.login } type="submit" className="btn btn-primary mt-2">Zaloguj się</button>

                { message.length>0 && <p className="form-text text-muted">{message}</p>}
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default LoginScreen


// WEBPACK FOOTER //
// ./src/screens/LoginScreen.js